import { SheetPageBody, SheetPageTitle } from "@/components/ui/sheet-page"
import {
  AlertCircle,
  Check,
  CheckCircle2,
  Mail,
  X,
  XCircle,
} from "lucide-react"
import { useNewProps } from "./page-props"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Link } from "@/lib/page-rendering"

export default function Page() {
  const { t } = useTranslation("school_relief_listings", {
    keyPrefix: "invitations.responses",
  })
  const { invitation } = useNewProps()
  const { school_name, relief_listing_title } = invitation
  return (
    <SheetPageBody>
      <SheetPageTitle icon={Mail}>
        {t("new.title", { school_name, relief_listing_title })}
      </SheetPageTitle>

      <div className="space-y-6">
        <p className="text-sm">
          {t(`new.status_description.${invitation.state}`, {
            relief_listing_title,
            school_name,
          })}
        </p>

        {(invitation.rejectable || invitation.acceptable) && (
          <Alert>
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>{t("new.warning")}</AlertDescription>
          </Alert>
        )}

        <div className="flex gap-3">
          {invitation.acceptable && (
            <Link
              as={Button}
              method="post"
              href="."
              data={{ response: "accept" }}
              className="flex-1"
            >
              <Check className="h-4 w-4" />
              {t("new.accept")}
            </Link>
          )}

          {invitation.rejectable && (
            <Link
              as={Button}
              method="post"
              href="."
              data={{ response: "reject" }}
              className="flex-1"
            >
              <X className="h-4 w-4" />
              {t("new.reject")}
            </Link>
          )}
        </div>

        <div className="space-y-3 text-sm">
          {invitation.acceptable && (
            <div className="flex gap-3">
              <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-green-600" />
              <div>
                <p className="font-medium">{t("new.accept_info.heading")}</p>
                <p>{t("new.accept_info.description")}</p>
              </div>
            </div>
          )}

          {invitation.rejectable && (
            <div className="flex gap-3">
              <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-red-600" />
              <div>
                <p className="font-medium">{t("new.reject_info.heading")}</p>
                <p>{t("new.reject_info.description")}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </SheetPageBody>
  )
}
